import React, { useState } from 'react';
import { Check, ClipboardCopy } from 'lucide-react';

const CopyButton = ({ code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <button
      onClick={handleCopy}
      className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl font-semibold shadow-md hover:from-blue-600 hover:to-purple-700 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
    >
      {copied ? (
        <>
          <Check size={18} className="text-green-300" />
          Copied!
        </>
      ) : (
        <>
          <ClipboardCopy size={18} />
          Copy Code
        </>
      )}
    </button>
  );
};

export default CopyButton;
